var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-container"},[_c('input',{staticClass:"search-bar",attrs:{"type":"text","placeholder":_vm.placeholder,"name":"search","autocomplete":"off"},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"submit"}},[_c('img',{staticClass:"search-icon",attrs:{"src":require("@/assets/magnifying-glass.png")}})])
}]

export { render, staticRenderFns }